module.exports = __webpack_public_path__ + "img/hawaii.3c5cfd2a.svg";